import React from "react";
import LogoIcon from "./Logo.svg";

const Logo = (props) => {
  return (
    <a href="/">
      <img src={LogoIcon} alt="Virtue Poker" width={props.width && props.width} height={props.height && props.height}/>
    </a>
  );
};

export default Logo;
